<template>
  <main class="mechanism">
    <div class="mechanism__checks">
      <CheckboxGroup />
    </div>

    <transition name="to-top-tr">
      <AddContent
        v-if="!verifChecksState"
        title="Make a selection above to compare"
      />

      <CardGroup v-else
        :list="getActiveCards"
        :enableScroll="false"
      />
    </transition>

    <footer class="mechanism__footer">The animations shown here are hypothetical.</footer>
  </main>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

import AddContent from '../../../jazz-components/src/components/UIComponents/AddContent.vue';
import CheckboxGroup from '../../../jazz-components/src/components/UIComponents/CheckboxGroup.vue';
import CardGroup from '../../../jazz-components/src/components/UIComponents/CardGroup.vue';

export default {
  name: 'Homepage',

  components: {
    AddContent,
    CheckboxGroup,
    CardGroup,
  },

  computed: {
    ...mapGetters(['activeChecks']),

    verifChecksState() {
      return this.activeChecks.some((item) => item.active);
    },

    getActiveCards() {
      return this.activeChecks.filter((item) => item.active);
    },
  },
};
</script>

<style lang="scss" scoped>
@include iPadProStyles {
  .cards-group {
    margin-top: 55px;
  }
}

.mechanism {
  overflow: hidden;
  position: relative;
  padding: rem(12) rem(20);

  &::v-deep {
    .add-content__circle {
      &:before {
        content: '';
        height: rem(1200);
        width: 1px;
        background: #4094af;
        position: absolute;
        top: rem(-1200);
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .add-content__title {
      max-width: rem(300);
    }
  }

  &__checks {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
    background: #f5f5f5;
    padding-top: rem(10);
  }

  &__content {
    background: $white;
    height: calc(100% - 180px);
    margin-top: rem(80);
  }

  &__footer {
    position: absolute;
    bottom: rem(5);
    left: rem(20);
    font-size: rem(10);
  }

  @include iPadProStyles {
    padding: rem(12) rem(45);

    &__footer {
      left: rem(45);
      font-size: rem(14);
    }
  }
}
</style>

